import { render, staticRenderFns } from "./quickCreate.vue?vue&type=template&id=fc28efaa"
import script from "./quickCreate.vue?vue&type=script&lang=js"
export * from "./quickCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports